import { render } from "./FormAdviceView.vue?vue&type=template&id=2e428bf5"
import script from "./FormAdviceView.vue?vue&type=script&lang=js"
export * from "./FormAdviceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__